import React from 'react';

export default function FooterEn({ ...rest }) {
  return (
    <div className="footer">
      <div className="container">
        <div className="footer-info">
          <div className="box-left box-info">
            <div className="title">© MINISTRY OF LABOUR – INVALIDS AND SOCIAL AFFAIRS (MOLISA) PORTAL</div>
            <div className="info">
              <span className="icon isax-location1" />
              <span className="text-m">Address: 12 Ngo Quyen Str, Hoan Kiem District, Ha Noi, Viet Nam</span>
            </div>
            <div className="info">
              <span className="icon isax-call1" />
              <span className="text-m">Tel: (+8424) 62703645 - (+8424) 39388407 | Fax: (+8424) 62703609</span>
            </div>
            <div className="ncsc">
              <a href="https://tinnhiemmang.vn/danh-ba-tin-nhiem/molisagovvn-1624937765">
                <img src="https://tinnhiemmang.vn/handle_cert?id=molisa.gov.vn" alt="https://tinnhiemmang.vn/handle_cert?id=molisa.gov.vn" />
              </a>
              &nbsp;
              <a href={`https://api.qrserver.com/v1/create-qr-code/?size=60x60&data=${window.location.href}`}>
                <img src={`https://api.qrserver.com/v1/create-qr-code/?size=60x60&data=${window.location.href}`} alt="ncsc.png" />
              </a>
            </div>
          </div>
          <div className="box-right box-info">
            <div className="desc">
              <div className="info">
                <span className="icon isax-sms1" />
                <span className="text-m">Email: banbientap@molisa.gov.vn - tiepnhanykien@molisa.gov.vn</span>
              </div>
              <div className="info">
                <span className="icon isax-building1" />
                <span className="text-m">
                  Specify the source of "Portal of the Ministry of Labour - Invalids and Social Affairs" or "http://www.molisa.gov.vn" when re-issuing information from this Portal
                </span>
              </div>
            </div>
            <div className="list-social">
              <a href="#">
                <img src="/assets/images/social/zalo.png" alt="/assets/images/social/zalo.png" />
              </a>
              <a href="#">
                <img src="/assets/images/social/fb.png" alt="/assets/images/social/fb.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
